<div class="title-grid">
    <img class="title-icon" [src]="'/assets/images/saved-lists.svg'" />
    <h2 translate>grid.navs.savedLists</h2>
</div>
<que-lists-collections></que-lists-collections>